<template>
  <vue-d3 :onExportPng="handleExportPng" :showExport="showExport">
    <div ref="vis-ref"></div>
  </vue-d3>
</template>

<script>
import { LineChart } from './LineChart';
import VueD3 from '../VueD3.vue';

export default {
  name: 'LineChartWrapper',
  components: {
    VueD3,
  },
  props: {
    exportTitle: String,
    exportFileName: String,
    showExport: {
      type: Boolean,
      default: false,
    },

    series: {
      type: Array,
      required: true,
    },
    width: Number,
    height: Number,
    pointRadius: Number,
    min: Number,
    max: Number,
    color: {
      type: Function,
    },
    colorType: String,
    valueAccessor: {
      type: Function,
    },
    valueFormat: {
      type: Function,
    },
    xField: {
      type: Function,
    },
    focalId: {
      type: String,
    },
    xType: String,
    // nodeTooltip: {
    //   type: Function,
    // },
    // onNodeClick: {
    //   type: Function,
    // },
  },
  data() {
    return {
      chartInstance: null,
    };
  },
  mounted() {
    this.chartInstance = new LineChart({
      target: this.$refs['vis-ref'],
      exportFileName: this.exportFileName,
      exportTitle: this.exportTitle,

      series: this.series,
      width: this.width,
      height: this.height,
      pointRadius: this.pointRadius,
      min: this.min,
      max: this.max,
      color: this.color,
      colorType: this.colorType,
      valueAccessor: this.valueAccessor,
      valueFormat: this.valueFormat,
      xField: this.xField,
      xType: this.xType,

      // focalId: this.focalId,
      // nodeTooltip: this.nodeTooltip,
      // onNodeClick: this.onNodeClick,
    });
    this.$emit('init', this.chartInstance);
  },
  watch: {
    focalId(newValue, oldValue) {
      if (this.chartInstance) {
        this.chartInstance.toggleFocus(newValue);
      }
    },
  },
  methods: {
    handleExportPng() {
      if (this.chartInstance) {
        this.chartInstance.exportToPng();
      }
    },
  },
};
</script>
